module.exports = __webpack_public_path__ + "static/media/FCMH-Logo-FORSCHUNGSCAMPUS-MITTELHESSEN-01-ffffff.4e1d9080.svg";